import { SVGProps } from 'react'
import { styled } from '../../config'

const SvgComponent = ({
  active,
  ...props
}: { active?: boolean } & SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={1}
      {...props}>
      <circle cx={28} cy={28} r={28} fill="#DE3136" />
      <g clipPath="url(#a)">
        <circle cx={28} cy={28} r={25.2} fill="#C5252A" />
      </g>
      <rect
        width={49.7}
        height={49.7}
        x={3.149}
        y={3.151}
        stroke="url(#b)"
        strokeWidth={0.7}
        rx={24.85}
      />
      <path
        fill="#fff"
        d="M22.243 14.225c.756-1.115.885-1.139.885-1.139s-.715-.226-1.164.435c-.754 1.113-.878 1.14-.878 1.14s.714.217 1.157-.436ZM26.801 33.876l8.895 8.894a12.417 12.417 0 0 0-3.35-6.104l-4.168-4.167-1.377 1.377ZM24.2 36.477l11.56 11.558c.161-.831.242-1.673.24-2.514L25.578 35.1 24.2 36.477ZM21.6 39.077l10.423 10.422c.84.002 1.682-.079 2.513-.241L22.977 37.7 21.6 39.077Z"
      />
      <path
        fill="#fff"
        d="M23.609 19.037c.85 0 1.599-.438 2.032-1.1a2.425 2.425 0 0 0 4.065 0 2.425 2.425 0 0 0 2.985.906l-.434 1.049H23.09l-.434-1.05c.293.126.615.195.953.195Zm.094-2.51c.69-1.76 2.916-2.635 3.942-3.364.282-.2.855-.77.842-1.52-.016-.86-.7-1.561-1.562-1.561-.806 0-1.977.906-2.532 1.455a1.074 1.074 0 0 0-.588-.47c.505-.88.689-1.697.826-2.608.337.143.707.222 1.096.222.646 0 1.243-.22 1.718-.589a3.165 3.165 0 0 0 2.463.947 3.375 3.375 0 0 0 1.155 2.241 5.119 5.119 0 0 0-1 1.116c-.661.971-1.356 1.462-1.821 1.702-.419.216-.73.275-.826.288a3.634 3.634 0 0 1-.163 2.06l.65.253a4.326 4.326 0 0 0 .287-1.755c.645-.252 1.607-.824 2.494-2.125.73-1.072 1.55-1.499 2.208-1.652-.15.353-.247.735-.28 1.138a3.649 3.649 0 0 0 .337 1.856 3.658 3.658 0 0 0-1.254 1.412 3.662 3.662 0 0 0-.225 2.745 1.732 1.732 0 0 1-1.345-1.087.62.62 0 1 0-.839 0 1.73 1.73 0 0 1-3.225 0 .62.62 0 1 0-.839 0 1.721 1.721 0 0 1-1.854 1.089c.005-.3.047-1.058.335-1.794Zm11.004 12.176-3.644 3.633-.835-.836c-1.421-1.42-1.806-3.164-1.947-5.345a52.052 52.052 0 0 1-.098-3.36v-2.153h3.829v2.152c0 2.266.831 4.072 2.695 5.909Zm-8.304 2.446v-7.726h-4.415l1.374-2.78h4.071v2.151c0 .64.006 1.982.1 3.41.09 1.405.288 2.742.851 3.95l-1.981.995Zm-.75.376-2.16 1.085c.054-1.19.073-2.945-.169-4.294-.28-1.56-.947-3.223-1.352-4.143h3.68v7.352ZM21.29 17.357l1.3 3.152-1.626 3.29s1.228 2.461 1.62 4.65c.382 2.123.073 5.419.073 5.419l6.077-3.059c.26.427.577.836.962 1.222l1.366 1.366 4.716-4.712-.311-.291c-1.897-1.778-2.706-3.452-2.706-5.6v-2.298l1.294-3.14a.619.619 0 1 0-.685-.178 1.732 1.732 0 0 1-1.177 1.1 2.968 2.968 0 0 1 .124-2.391 2.968 2.968 0 0 1 1.617-1.45 2.956 2.956 0 0 1-.627-2.076c.062-.777.42-1.46.952-1.948-.34-.077-1.428-.24-2.606.447a2.677 2.677 0 0 1-1-2.702A2.477 2.477 0 0 1 27.508 7a2.108 2.108 0 0 1-3.552.017c.158 1.747-.366 3.805-1.855 4.895l.405.537c.243-.183.489-.389.7-.608.093-.096.185-.152.311-.15a.356.356 0 0 1 .347.356c0 .09-.034.155-.067.22a1.552 1.552 0 0 0-.013 1.353l.61-.287c-.284-.611.202-1.181.971-1.752.553-.41 1.135-.795 1.56-.798a.859.859 0 0 1 .86.86c0 .533-.526.957-.932 1.213-1.521.96-3.056 1.659-3.764 3.346-.298.708-.392 1.437-.422 1.848a1.881 1.881 0 0 1-.69-.872.618.618 0 0 0-.471-1.02.62.62 0 0 0-.215 1.198ZM19 41.677l4.167 4.167a12.412 12.412 0 0 0 6.104 3.35L20.377 40.3 19 41.677Z"
      />
      <path
        fill="#fff"
        d="M25.346 9.242a.399.399 0 1 0 0 .798.399.399 0 0 0 0-.798ZM30.538 22.539h-.75v.884h-.884v.75h.884v.884h.257v1.146h.236v-1.146h.257v-.884h.884v-.75h-.884v-.884Z"
      />
      <defs>
        <linearGradient
          id="b"
          x1={27.999}
          x2={27.999}
          y1={2.801}
          y2={53.201}
          gradientUnits="userSpaceOnUse">
          <stop stopOpacity={1} />
          <stop offset={1} stopOpacity={1} />
        </linearGradient>
        <clipPath id="a">
          <rect
            width={50.4}
            height={50.4}
            x={2.799}
            y={2.801}
            fill="#fff"
            rx={25.2}
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const AuxiliarAdministrativoGeneralitatValenciana = styled(SvgComponent, {
  shouldForwardProp: (prop) => prop !== 'active',
})
